module.exports = __webpack_public_path__ + "static/img/wheel-loop.98e8c3fd.png";